import mainApiMock from './mock/main';
import exchangeApiMock from './mock/exchange';
import pointApiMock from './mock/point';
import userInfoApiMock from './mock/userInfo';
import certificationApiMock from './mock/certification';
import authNJApiMock from './mock/authNJ';

import mainApiServer from './server/main';
import exchangeApiServer from './server/exchange';
import pointApiServer from './server/point';
import userInfoApiServer from './server/userInfo';
import certificationApiServer from './server/certification';
import authNJApiServer from './server/authNJ';

let mainApi, exchangeApi, pointApi, userInfoApi, certificationApi, authNJApi;

if (process.env.VUE_APP_API_CLIENT === 'mock') {
  mainApi = mainApiMock;
  exchangeApi = exchangeApiMock;
  pointApi = pointApiMock;
  userInfoApi = userInfoApiMock;
  certificationApi = certificationApiMock;
  authNJApi = authNJApiMock;
} else {
  mainApi = mainApiServer;
  exchangeApi = exchangeApiServer;
  pointApi = pointApiServer;
  userInfoApi = userInfoApiServer;
  certificationApi = certificationApiServer;
  authNJApi = authNJApiServer;
}

export { mainApi, exchangeApi, pointApi, userInfoApi, certificationApi, authNJApi };
